import axios from 'axios';
import { useCallback, useState } from 'react';

export type UploadFileParams = {
  url: string;
  fields: Record<string, string>;
  file: File;
};

export type UseUploadFileToBucket = () => [number, (params: UploadFileParams) => Promise<boolean>];

export const useUploadFileToBucket: UseUploadFileToBucket = () => {
  const [progress, setProgress] = useState<number>(0);

  const uploadFile = useCallback<(params: UploadFileParams) => Promise<boolean>>(async params => {
    const { fields, url, file } = params;
    const formData = new FormData();

    Object.keys(fields).forEach(k => {
      const v = fields[k];
      formData.append(k, v);
    });

    formData.append('file', file);

    const response = await axios
      .post(url, formData, {
        onUploadProgress: (progressEvent: ProgressEvent) => {
          const { total, loaded } = progressEvent;
          setProgress(Math.round((loaded / total) * 100));
        },
      })
      .catch(e => e.response);

    return response.status < 400;
  }, []);

  return [progress, uploadFile];
};
